"use strict";

import Swiper from "swiper";
import { Navigation, Autoplay } from "swiper/modules";

document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".gallery-slider").forEach((slider) => {
        const prevBtn = slider.querySelector(".arrows-prev");
        const nextBtn = slider.querySelector(".arrows-next");

        new Swiper(slider, {
            modules: [Navigation, Autoplay],
            slidesPerView: "auto",
            spaceBetween: 30,
            grabCursor: true,
            loop: false,
            speed: 600,
            navigation: {
                prevEl: prevBtn,
                nextEl: nextBtn,
            },
        });
    });
});